import { render, staticRenderFns } from "./expertMatching.vue?vue&type=template&id=0c8fcb65&"
import script from "./expertMatching.vue?vue&type=script&lang=js&"
export * from "./expertMatching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports